<template>
    <div class="table-responsive">
        <loading-indicator :loading="loading" />
        <p class="readable-text" v-if="!loading && scheduledReports && scheduledReports.length == 0">
            Try scheduling some reports by clicking on "Schedule new reports"!
        </p>
        <table v-if="scheduledReports && scheduledReports !== null && scheduledReports.length > 0" class="table">
            <thead>
                <tr>
                    <th class="align-middle">
                        Report Type
                    </th>
                    <th class="align-middle">
                        Day Offset
                    </th>
                    <th class="align-middle">
                        Hour
                    </th>
                    <th class="align-middle">
                        Frequency
                    </th>
                    <th class="align-middle">
                        Emails
                    </th>
                    <th class="align-middle">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="report in formattedReports" :key="report.id">
                    <td class="align-middle">
                        {{ report.report_type }} ({{ report.period_type }})
                    </td>
                    <td class="align-middle">
                        {{ report.day_offset }}
                    </td>
                    <td class="align-middle">
                        {{ report.sending_hour + ':00' }}
                    </td>
                    <td class="align-middle">
                        {{ report.frequency }}
                    </td>
                    <td class="align-middle">
                        {{ report.emails }}
                    </td>
                    <td class="text-right">
                        <button
                            class="btn btn-default btn-rounded"
                            @click="() => deleteSchedule(report.id)"
                        >
                            <i class="fa fa-times"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import LoadingIndicator from '../LoadingIndicator.vue';
export default {
  components: { LoadingIndicator },
    props: ["teams", "group_id", "user"],
    data() {
        return {
            scheduledReports: null,
            loading: false
        };
    },
    mounted() {
        this.getScheduledReports();
    },
    computed: {
        formattedReports() {
            let reports = [];
            this.scheduledReports.forEach(report => {
                reports.push({
                    id: report.id,
                    day_offset: report.day_offset,
                    sending_hour: report.sending_hour,
                    period_type: this.labelizeGeneral(report.period_type),
                    report_type: this.labelizeGeneral(report.report_type),
                    frequency: this.labelizeGeneral(report.frequency),
                    emails: JSON.parse(report.emails).join(", ")
                });
            });

            return reports;
        }
    },
    methods: {
        async getScheduledReports() {
            let link = "/api/report/schedule/group/" + this.group_id;

            this.loading = true;
            let response = await axios.get(link);
            this.loading = false;
            this.scheduledReports = response.data;
        },
        async deleteSchedule(scheduleId) {
            let link =
                "/api/report/schedule/group/" +
                this.group_id +
                "/" +
                scheduleId;

            try {
                let body = {
                    id: scheduleId
                };
                let response = await axios.delete(link);
                this.getScheduledReports();
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>
